<template>
  <div class="submission__file-media">

    <div class="file-media__item">
      <el-alert
        title="This section is optional."
        type="info"
        show-icon
      />
      <sh-spacer by="1"/>
      <el-alert
        title="Do not use special characters for the file name such as ~`!@#$%^&*()-_+={}[]|\/:;'<>,.? etc."
        type="info"
        show-icon
      />

      <sh-spacer by="3"/>

      <!-- <sh-inliner>
      NOTE: WITH PREVIEW
        <h2>Stills</h2>
      </sh-inliner>
      <FileMediaItemDescription>
        More of the description will be updated later
      </FileMediaItemDescription>
      NOTE: PROBLEM 1, ATTACHMENTS API DOES NOT RETURN IMAGE URL SO NO PREVIEW
      PROBLEM 2 IS FILE_KEY THE URL FOR IMAGE?
      PROBLEM 3 IF WE USE IMAGE API WE CANT INCLUDE CATEGORY
      <UploadDragShow
        :action="getUploadUrl('image')"
        :file-list="[{url:'dev_submissions/1232016/posters/screencapture-localhost-3000-missions-2023-03-13-16_21_41.png'}]"
        :headers="requestHeaders"
        :data="{
          category: categories.STILLS,
        }"
        :on-remove="handleRemove('Stills')"
        :on-success="handleAdd('Stills')"
        :on-error="handleError"
        :disabled="!editable"
        multiple
      /> -->
    </div>

    <FileMediaItem
      class="file-media__item"
      :action="getUploadUrl('attachments')"
      :request-headers="requestHeaders"
      :data="{
        category: categories.STILLS,
      }"
      :on-remove="handleRemove('Stills')"
      :on-success="handleAdd('Stills')"
      :file-list="fileListForStills"
      :disabled="!editable"
      :accept="'image/png'"
    >
      <template slot="title">
        <h2>Stills</h2>
      </template>
      <template slot="description">
        Upload image stills from your film. Recommended specs: 1920x1080 in PNG 
      </template>
    </FileMediaItem>

    <FileMediaItem
      class="file-media__item"
      :action="getUploadUrl('attachments')"
      :request-headers="requestHeaders"
      :data="{
        category: categories.TRAILER,
      }"
      :on-remove="handleRemove('Trailer')"
      :on-success="handleAdd('Trailer')"
      :file-list="fileListForTrailers"
      :disabled="!editable"
      :accept="'video/*'"
    >
      <template slot="title">
        <h2>Trailer</h2>
      </template>
      <template slot="description">
        Upload your trailer. Recommended specs: 1920 x 1080 (16:9) in MP4 / MOV H.264
      </template>
    </FileMediaItem>

    <!-- <div class="margin-bottom_32">
      NOTE: WITH PREVIEW
      <sh-inliner>
        <h2>Key Art (Posters)</h2>
      </sh-inliner>
      <FileMediaItemDescription>
        More of the description will be updated later
      </FileMediaItemDescription>
      
      <UploadDragShow
      :action="getUploadUrl('attachments')"
      :file-list="fileListForPosters"
      :headers="requestHeaders"
      :data="{
        category: categories.POSTERS,
      }"
      :on-remove="handleRemove('Posters')"
      :on-success="handleAdd('Posters')"
      :on-error="handleError"
      :disabled="!editable"
      multiple
      />
    </div> -->

    <FileMediaItem
      class="file-media__item"
      :action="getUploadUrl('attachments')"
      :request-headers="requestHeaders"
      :data="{
        category: categories.POSTERS,
      }"
      :on-remove="handleRemove('Poster')"
      :on-success="handleAdd('Poster')"
      :file-list="fileListForPosters"
      :disabled="!editable"
      :accept="'image/png'"
    >
      <template slot="title">
        <h2>Poster</h2>
      </template>
      <template slot="description">
        Upload your film’s poster key art. Recommended specs: 1920x1080 in PNG
      </template>
    </FileMediaItem>

    <div class="file-media__item">
      <!-- This component will work closely with the subtitle file_attachment api -->
      <SubtitleUploader
        :action="getUploadUrl('attachments')"
        :headers="requestHeaders"
        :data="{
          note: 'en',
          category: categories.SUBTITLES,
        }"
        :on-remove="handleRemove('Subtitles')"
        :on-success="handleAdd('Subtitles')"
        :on-change="handleChange('Subtitles')"
        multiple
        :file-list="fileListForSubtitles"
        :disabled="!editable"
        :accept="'.srt'"
      >
        <FileMediaItemHeader
          :disabled="!editable"
        >
          <h2>Subtitles</h2>
        </FileMediaItemHeader>

        <FileMediaItemDescription>
          Upload subtitle files. Recommended specs: SRT (SubRip Text) File, for burned-in subtitles: Helvetica Neue Reg with outline or Roboto Reg with outline – Size 42        </FileMediaItemDescription>
      </SubtitleUploader>
      <FileMediaItemListEmptyState :file-list="fileListForSubtitles" />
    </div>

    <sh-spacer by="3.5"/>

    <FileMediaItem
      class="file-media__item"
      :action="getUploadUrl('attachments')"
      :request-headers="requestHeaders"
      :data="{
        category: categories.MUSIC_LICENSE,
      }"
      :on-remove="handleRemove('MusicLicense')"
      :on-success="handleAdd('MusicLicense')"
      :file-list="fileListForMusicLicense"
      :disabled="!editable"
    >
      <template slot="title">
        <h2>Music License Usage Form/ Cue Sheets</h2>
      </template>
      <template slot="description">
        Upload your license usage documents, or if you only have the confirmation over email, attach a screenshot.
        We take music license infringement seriously. If you haven't acquired permissions for the audio tracks used in your work, please obtain them from the rightful owner or replace it before submitting to us.
      </template>
    </FileMediaItem>

    <sh-spacer by="3.5"/>

    <FileMediaItem
      class="file-media__item"
      :action="getUploadUrl('attachments')"
      :request-headers="requestHeaders"
      :data="{
        category: categories.OTHERS,
      }"
      :on-remove="handleRemove('Others')"
      :on-success="handleAdd('Others')"
      :file-list="fileListForOthers"
      :disabled="!editable"
    >
      <template slot="title">
        <h2>Others</h2>
      </template>
      <template slot="description">
          If you're submitting for Juree Asia Awards 2023, we encourage you to upload:<br/>
          - Director Bio (Tell us about yourself and your filmmaking journey in maximum 100 words in .docx or .pdf file)<br/>
          - Director Photo (upload your headshot in PNG with at least 300 ppi)
      </template>
    </FileMediaItem>
  </div>
</template>

<script>
import Vue from 'vue';
import Upload from 'element-ui/lib/upload';

import webcall from '@/libs/webcall';
import variables from '@/config/variables';
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import {
  NGINX_UPLOAD_LIMIT,
  ONE_MEGABYTES,
} from '@/config/magic-values';
import UploadDragShow from '../FilesMedia/UploadDragShow';
import SubtitleUploader from '../FilesMedia/SubtitleUploader';
import FileMediaItem from '../FilesMedia/FileMediaItem';
import FileMediaItemHeader from '../FilesMedia/FileMediaItemHeader';
import FileMediaItemDescription from '../FilesMedia/FileMediaItemDescription';
import FileMediaItemListEmptyState from '../FilesMedia/FileMediaItemListEmptyState';
import stepMixin from '../../Mixins/stepMixin';

Vue.use(Upload);

const categories = {
  OTHERS: 'others',
  MUSIC_LICENSE: 'music_license',
  SUBTITLES: 'subtitles',
  STILLS: 'stills',
  TRAILER: 'trailer',
  POSTERS: 'posters',
};

export default {
  name: 'files',
  mixins: [
    stepMixin,
  ],
  components: {
    UploadDragShow,
    SubtitleUploader,
    FileMediaItem,
    FileMediaItemHeader,
    FileMediaItemDescription,
    FileMediaItemListEmptyState,
  },
  props: [
    'value',
  ],
  data() {
    return {
      requestHeaders: webcall.getHeader(),
      dialogImageUrl: '',
      dialogVisible: false,
      categories,

      // Create a shallow copy of the items. All items in here should be self
      // managed i.e. data is manually sync and is a reflection of the
      // submission object
      // fileListForStills: this.value.image,
      fileListForOthers: this.value.attachments.filter(attachment => attachment.category === categories.OTHERS),
      fileListForMusicLicense: this.value.attachments.filter(attachment => attachment.category === categories.MUSIC_LICENSE),
      fileListForSubtitles: this.value.attachments.filter(attachment => attachment.category === categories.SUBTITLES),
      fileListForStills: this.value.attachments.filter(attachment => attachment.category === categories.STILLS),
      fileListForTrailers: this.value.attachments.filter(attachment => attachment.category === categories.TRAILER),
      fileListForPosters: this.value.attachments.filter(attachment => attachment.category === categories.POSTERS),
    };
  },
  watch: {
    fileListForMedia() { this.updateForm(); },
    fileListForOthers() { this.updateForm(); },
    fileListForMusicLicense() { this.updateForm(); },
    fileListForStills() { this.updateForm(); },
    fileListForTrailers() { this.updateForm(); },
    fileListForPosters() { this.updateForm(); },
  },
  methods: {
    updateForm() {
      // Trigger store update
      this.$emit('input');
    },
    getUploadUrl(type = 'attachments') {
      return (`${variables.API_URL}submitvideo/${this.value.id}/${type}`);
    },


    /**
     * Handle changes made to the attachment
     * @param {string} type of the attachment
     * @returns a callback function used by another component on its change event.
     *          null if no appropriate function is defined.
     */
    handleChange(type) {
      if (type === 'Subtitles') {
        /**
         * A callback function used to update the note of the attachment. The
         * note of Subtitles attachment stores the language of the subtitle.
         * @param {object} file object of the attachment
         * @param {string} note in the format of 'subtitles-{languageCode}'
         */
        // TODO: This does not confort with the current framework. i.e. web
        // update is not being handled by the parent component (submission)
        // Consequently,
        //   1. networkActivity will not be ran
        //   2. need to manually update client data (not reactive)
        return (file, note) => webcall.submission.attachments.update(this.value.id, file.id, {
          note,
        })
        // Find and update the relevant attachment
          .then(({ data }) => {
            const fileList = this[`fileListFor${type}`];
            const index = fileList.findIndex(listFile => listFile.uid === file.uid);
            this.$set(fileList, index, data);
            this.$set(this, `fileListFor${type}`, fileList);
          })
          .catch((error) => {
          // TODO: Ponder. Should we handle error notification globally from
          // webcall? Or should we do it in the relevant component individually?
            this.$notify.error({
              title: 'Error',
              message: 'Unable to update subtitle language. Please try again later.',
              duration: NOTIFY_CONSTANTS.DURATION.MEDIUM,
            });
            throw error;
          });
      }
      return null;
    },


    handleRemove(type) {
      const endpoint = (type === 'Media') ? 'image' : 'attachments';

      return (file, fileList) => {
        // Item may not be available on the server yet. In this case, just
        // remove it from the client side.
        if (file.status === 'uploading') {
          this.$set(this, `fileListFor${type}`, fileList);
          return;
        }
        if (file.status === 'success') {
          webcall.submission[endpoint].delete(this.value.id, file.id)
            .then(() => {
              this.$set(this, `fileListFor${type}`, fileList);
            })
            .catch((error) => {
            /**
             * Most likely occur due to server or network error.
             * When this happen, restore the file that was previously deleted back to the list
             * Then inform user about the error.
             */
              this.$notify.error({
                title: 'Error',
                message: 'Unable to delete file.',
                duration: NOTIFY_CONSTANTS.DURATION.SHORT,
              });
            });
        }
      };
    },
    handleAdd(type) {
      return (response, file, fileList) => {
        /**
         * Merge the response and file data together.
         * - `file` is needed to indicate the upload progress.
         * - `response` contain the actual file data from server
         *
         * keys in `response` will override the keys in `file`
         */
        const replacement = {
          ...file,
          ...response,
        };
        const index = fileList.findIndex(listFile => listFile.uid === file.uid);

        this.$set(fileList, index, replacement);
        this.$set(this, `fileListFor${type}`, fileList);
      };
    },

    handleError(err, file, fileList) {
      this.$notify.error({
        title: 'Error',
        message: (
          err.target.status
            ? (err.message || 'Unable to upload now. Please contact us if the error persist.')
            : `Server stopped the uploading. This may happen if the file size exceed ${
              (NGINX_UPLOAD_LIMIT/ONE_MEGABYTES).toFixed(0)
            } MB.`
        ),
        duration: NOTIFY_CONSTANTS.DURATION.MEDIUM,
      });
    },
  },
};
</script>

<style lang="scss">
.empty-data {
  font-size: 0.8em;
  opacity: 0.6;
}

.submission__file-media {
  .el-upload {
    text-align: left;
  }
  .el-upload.el-upload--picture-card {
    text-align: center;
  }

  .el-upload-list--picture-card,
  .el-upload-list__item-thumbnail {
    object-fit: cover;
  }
}

// Standardise component spacing in submission page
.file-media__item {
  margin-bottom: 2em;
}

.margin-bottom_32 {
  margin-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/NewFilesMedia/index.vue